import { type TagColorPalette } from '../canvas-element/tags';

export function makeStylesForTag(
  value: string,
  palette: TagColorPalette | undefined,
  fallbackColorInfo?: { foreground?: string; background?: string },
): {
  color?: string;
  background?: string;
} {
  if (!palette) {
    return {};
  }

  let foreground: string | undefined = '';
  let background: string | undefined = '';

  if (palette.type === 'single') {
    foreground = palette.single?.foreground;
    background = palette.single?.background;
  } else {
    const colors =
      palette.valuesMap && value in palette.valuesMap
        ? palette.valuesMap?.[value]
        : fallbackColorInfo;
    foreground = colors?.foreground;
    background = colors?.background;
  }

  return {
    color: foreground || '#000',
    background: background || '#fff',
  };
}
